import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('public');
    }

    /* TODO clearly split public resources from the ones requiring authentication */

    listOffers (params) {
        return this.client.request({
            method: 'get',
            path: '/public/v1/offers',
            params: params,
        });
    }

    categories () {
        return this.client.request({
            method: 'get',
            path: '/public/v1/dict/categories',
            params: { limit: -1 },
        });
    }

    countries () {
        return this.client.request({
            method: 'get',
            path: '/public/v1/dict/countries',
            params: { limit: -1 },
        });
    }

    tagsOS () {
        return this.client.request({
            method: 'get',
            path: '/public/v1/tags/os',
            params: { limit: -1 },
        });
    }

}

export default new Resource;
